module.exports = __webpack_public_path__ + "img/shopify.b9c3494.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/shopify.png
// module id = f+N4
// module chunks = 39 44